export const DATE_TIME_PICKER_CONST = {
  VARIANT: {
    DATE: 'DATE',
    TIME: 'TIME',
    DATE_TIME: 'DATE_TIME',
  },
};



// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomDateTimePicker/Constants.js